module.exports = __webpack_public_path__ + "img/goodsD1.0fc8f0cb.png";